import { FC } from "react";
import { Box, Flex, Heading, Image } from "@chakra-ui/react";

import CustomWrapper from "components/Chakra/CustomWrapper";
import NewSearchFilter from "./components/NewSearchFilter";

interface ISearchBox {
  title?: string;
  subtitle?: string;
  heroSrc?: string;
  dataTest?: string;
}

const Searchbox: FC<ISearchBox> = ({
  title = "Největší nabídka pronájmů",
  subtitle = "Od soukromých majitelů i realitních kanceláří na jednom místě.",
  heroSrc = "/img/scenes/NewHomepage/hero.webp",
  dataTest,
}) => (
  <Flex
    position="relative"
    minH={{ base: "570px", md: "500px" }}
    transition="0.3s"
    data-test={dataTest}
  >
    <Box
      w="100%"
      minW={{ base: "100%", md: "1400px" }}
      h="100%"
      position="absolute"
      left="50%"
      transform="translateX(-50%)"
      transition="0.3s"
      data-test={`${dataTest}.background`}
    >
      <Image
        src={heroSrc}
        alt="hero"
        w="100%"
        h="100%"
        objectFit="cover"
        objectPosition="50% 80%"
        filter="brightness(0.7)"
      />
    </Box>

    <CustomWrapper
      data-test={`${dataTest}.content`}
      maxW="1170px"
      w="100%"
      position="relative"
      margin={{ base: "40px auto", md: "80px auto 113px auto" }}
    >
      <Heading
        as="h1"
        lineHeight={{ base: "44px", md: "57px" }}
        variant="h1"
        textColor="ud-white"
        fontSize={{ base: "40px", md: "50px" }}
        data-test={`${dataTest}.content.title`}
      >
        {title}
      </Heading>

      <Heading
        as="h2"
        variant="h3"
        mt="16px"
        fontSize="20px"
        textColor="white"
        fontWeight={400}
        textAlign="center"
        data-test={`${dataTest}.content.subtitle`}
      >
        {subtitle}
      </Heading>
      <NewSearchFilter />
    </CustomWrapper>
  </Flex>
);

export default Searchbox;
